<!-- src/layouts/HomeLayout.vue -->
<template>
    <AppHeader />
    <MobileHeaderNav />

    <div id="app-container">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div id="MainContentWrappper">
              <div id="MainContainer">

                <div id="ContentWrapper">
                  <Sidebar />
                  <main id="MainContent">
                    <!-- Top horizontal navigation bar -->
                    <div id="navigationBar">
                      <div class="container">
                        <div class="row">
                          <div class="col-12">
                            <div class="menu__list__wrapper">
                              <div class="menu__list">
                                <div class="menu__track" id="menuTrack" ref="menuTrackRef">
                                  <div
                                    v-for="(item, i) in navItems"
                                    :key="`${item.name}-${i}`"
                                    class="market-games"
                                  >
                                    <div class="spec-icon" v-if="item.badge">
                                      <img :src="item.badge" :alt="item.badgeAlt || 'New'" />
                                    </div>

                                    <RouterLink :to="{ name: item.name }" :class="linkClass(item.name)">
                                      <img :src="item.icon" :alt="item.label" />
                                    </RouterLink>
                                  </div>
                                </div>
                              </div>

                              <button
                                class="nav-btn prev"
                                id="prevBtn"
                                ref="prevBtnRef"
                                type="button"
                                @click="onPrev"
                              >
                                <i class="fi fi-tr-angle-small-left"></i>
                              </button>
                              <button
                                class="nav-btn next"
                                id="nextBtn"
                                ref="nextBtnRef"
                                type="button"
                                @click="onNext"
                              >
                                <i class="fi fi-tr-angle-small-right"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <RouterView />
                  </main>
                </div>
              </div>

              <!-- BetSlip is controlled by route meta.showBetSlip -->
              <BetSlip v-if="showBetSlip" />
            </div>

            <div class="overlay" id="overlay" @click="closeSideMenu"></div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
    <FooterNav />
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue'
import { RouterLink, useRoute } from 'vue-router'

import AppHeader from '@/components/AppHeader.vue'
import MobileHeaderNav from '@/components/MobileHeaderNav.vue'
import Sidebar from '@/components/SideBar.vue'
import Footer from '@/components/Footer.vue'
import FooterNav from '@/components/FooterNav.vue'
import BetSlip from '@/components/BetSlip.vue'

import { useBetSlip } from '@/composables/useBetSlip'
import { TOP_NAV } from '@/constants/topNav'

const { showBetSlip } = useBetSlip()
const route = useRoute()
const navItems = TOP_NAV

function linkClass(name) {
  return { 'active-game': route.name === name }
}

function closeSideMenu() {
  const el = document.getElementById('sideMenuBar')
  if (el) el.classList.remove('show', 'open')
  const overlay = document.getElementById('overlay')
  if (overlay) overlay.classList.remove('show', 'open')
}

// Horizontal scroller (same behavior as DefaultLayout)
const menuTrackRef = ref(null)
const prevBtnRef = ref(null)
const nextBtnRef = ref(null)

function updateButtons() {
  const el = menuTrackRef.value,
    prev = prevBtnRef.value,
    next = nextBtnRef.value
  if (!el || !prev || !next) return
  prev.disabled = el.scrollLeft <= 0
  next.disabled = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1
}
function onPrev() {
  menuTrackRef.value?.scrollBy({ left: -200, behavior: 'smooth' })
}
function onNext() {
  menuTrackRef.value?.scrollBy({ left: 200, behavior: 'smooth' })
}
function onScroll() {
  updateButtons()
}
function onResize() {
  updateButtons()
}

onMounted(async () => {
  await nextTick()
  const el = menuTrackRef.value
  if (!el) return
  el.addEventListener('scroll', onScroll)
  window.addEventListener('resize', onResize)
  const imgs = Array.from(el.querySelectorAll('img'))
  let pending = imgs.length
  const done = () => {
    pending -= 1
    if (pending <= 0) updateButtons()
  }
  if (pending === 0) updateButtons()
  imgs.forEach((img) => {
    if (img.complete) done()
    else {
      img.addEventListener('load', done, { once: true })
      img.addEventListener('error', done, { once: true })
    }
  })
})

onBeforeUnmount(() => {
  const el = menuTrackRef.value
  if (el) el.removeEventListener('scroll', onScroll)
  window.removeEventListener('resize', onResize)
})
</script>
